import { useState, useEffect } from "react";

const useViewType = () => {
  const [viewType, setViewType] = useState(
    (localStorage.getItem('managerViewType') || localStorage.getItem('viewType') || 'manager').toLowerCase()
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setViewType(
        (localStorage.getItem('managerViewType') || localStorage.getItem('viewType') || 'manager').toLowerCase()
      );
    };

    window.addEventListener('managerViewTypeChanged', handleStorageChange);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('managerViewTypeChanged', handleStorageChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const isAdminView = viewType === 'admin';
  const isManagerView = viewType === 'manager';

  return { viewType, isAdminView, isManagerView };
};

export default useViewType;